<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import { reactive, onBeforeMount } from 'vue';
import axios from 'axios';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { formatDate } from '@/assets/js/utils';
import Footer from '@/components/Footer.vue';
import Placeholder from '@/components/Placeholder.vue';
import NavbarSecondDark from '@/components/NavbarSecondDark.vue';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

// Define refs and reactive state
const store = useStore();
const route = useRoute();
const result = reactive({
  data: null,
  loading: false,
});

// Function to get event details
function getEventDetail() {
  result.loading = true;
  axios
    .get(`${store.state.urlNewEventFront}event/${route.params.id}`)
    .then((response) => {
      result.data = response.data?.data;
      result.loading = false;
    })
    .catch((error) => {
      console.log(error);
      result.loading = false;
    });
}

// Call the function before the component mounts
onBeforeMount(() => {
  getEventDetail();
});

// Expose variables to the template
</script>

<template>
  <div>
    <NavbarSecondDark />
    <section class="container-xl my-5 px-lg-5">&nbsp;</section>

    <section class="container-xl my-5 px-lg-5">
      <div class="row px-lg-5" v-if="result.loading">
        <div class="col-lg-8">
          <Placeholder />
        </div>
        <div class="col-lg-4">
          <Placeholder />
        </div>
      </div>
      <div class="row px-lg-5" v-if="result.data != null">
        <div class="col-lg-12 mb-3">
          <div class="card text-bg-dark border-0 rounded-3 shadow">
            <img :src="result.data?.photo_formated" class="card-img rounded-3 border-0 d-none d-lg-block"
              alt="Event banner" style="width: 100%; height: 446px" />
            <img :src="result.data?.photo_formated" class="card-img rounded-3 border-0 d-lg-none" alt="Event banner"
              style="width: 100%" />
          </div>
        </div>
        <div class="col-lg-12 mt-4">
          <div class="h1 text-primary-mice fw-bold">
            {{ result.data?.name }}
          </div>
          <div class="col-lg-12 mb-2 gap-2 d-flex flex-wrap">
            <span class="small badge text-primary-mice" style="background-color: #EFEEEE;"> <i
                class="fas fa-calendar-days me-1"></i> {{
                  formatDate(result.data?.start_event, "LLLL")
                }}</span>
            <span class="small badge text-primary-mice" style="background-color: #EFEEEE;"> <i
                class="fas fa-location-dot me-1"></i> {{ result.data?.province?.name }}, {{ result.data?.city?.name
              }}</span>
          </div>
        </div>
        <div class="col-lg-12 pt-4">
          <div class="" v-html="result.data.description"></div>
        </div>
        <div class="col-lg-12 pt-4 d-flex flex-column gap-3">
          <router-link v-for="(data, i) in result.data.registration_forms" :key="i" :to="{
            name: 'EventRegistration',
            params: {
              id: route.params.id,
              registrationFormId: data.uuid,
            },
          }" class="btn btn-primary rounded-custom text-white px-3 py-2 d-block d-lg-inline" :title="data.name">Form: {{
            data.name }}</router-link>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>
